import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';

import './services';

import { Provider } from 'react-redux';
import { ConfigProvider } from './contexts/ConfigContext';

import './index.scss';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import Logoloder from './assets/images/loader/Logoloder';



const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <ConfigProvider>
      <App />

  {/* <Logoloder/> */}
    
    </ConfigProvider>
  </Provider>
);

reportWebVitals();
